export function roleJudge(userRoleArray, role1, role2, role3, role4) {
  return userRoleArray.some(e => {
    return e == role1 || e == role2 || e == role3 || e == role4;
  });
}
